module.exports = __webpack_public_path__ + "fonts/VetoSans-Light_3.965892ac.eot";